import { AgTechLink, AgTechLinkProps } from '../../Buttons/AgTechButtons'
import React from 'react'

const AgTechGridLink = (props: AgTechLinkProps) => {
    return (
        <AgTechLink
            {...props}
            classes={`px-3 text-sm ${props.classes ?? ''}`}
        />
    )
}

export default AgTechGridLink